import { onSensitiveMemoryCacheClear } from './sensitive-cache-lifecycle';
import type { ResourceScope } from '@kop/contracts';

let generation = 0;
onSensitiveMemoryCacheClear(() => { generation += 1; });

export type HeadquartersReadContext = Readonly<{ uid: string; siteId: string; generation: number }>;

export function createHeadquartersReadContext(uid: string, siteId: string): HeadquartersReadContext | null {
  if (!uid || !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(siteId)) return null;
  return { uid, siteId, generation };
}

/** Navigation preference only; the destination must independently verify site authority. */
export function headquartersReadSite(context: HeadquartersReadContext | null | undefined, uid: string, sites: readonly { siteId: string }[]): string | null {
  if (!context || !uid || context.uid !== uid || context.generation !== generation) return null;
  return sites.some(site => site.siteId === context.siteId) ? context.siteId : null;
}

/** Carries a navigation preference only; the server independently authorizes every read. */
export function headquartersWorkScope(resource: ResourceScope, role: string, uid: string, context: HeadquartersReadContext | null): ResourceScope {
  if (resource.kind !== 'tenant' || !['hqSafety', 'hqAudit'].includes(role)
    || !uid || !context || context.uid !== uid || context.generation !== generation
    || !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(context.siteId)) return resource;
  return { kind: 'site', tenantId: resource.tenantId, siteId: context.siteId };
}
